import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "BaseJournalPopup column no-wrap full-height bg-white rounded-20"
}
const _hoisted_2 = { class: "full-width full-height overflow-auto hide-scrollbar" }
const _hoisted_3 = { class: "column gap-12 full-width q-mb-12 q-pb-md" }
const _hoisted_4 = { class: "flex items-center gap-sm" }
const _hoisted_5 = { class: "fs-13px fw-500 tex-cool-gray-100 q-mb-none" }
const _hoisted_6 = { class: "fs-13px fw-500 text-cool-gray-80" }
const _hoisted_7 = { class: "flex items-center gap-sm" }
const _hoisted_8 = { class: "fs-13px fw-500 tex-cool-gray-100 q-mb-none" }
const _hoisted_9 = { class: "fs-13px fw-500 text-cool-gray-80" }
const _hoisted_10 = { class: "flex items-center gap-sm" }
const _hoisted_11 = { class: "fs-13px fw-500 tex-cool-gray-100 q-mb-none" }
const _hoisted_12 = { class: "fs-13px fw-500 text-cool-gray-80" }
const _hoisted_13 = { class: "fs-15px fw-400 text-cool-gray-100" }
const _hoisted_14 = { class: "fs-15px fw-400 text-cool-gray-100" }
const _hoisted_15 = { class: "fs-15px fw-400 text-cool-gray-100" }
const _hoisted_16 = { class: "fs-15px fw-400 text-cool-gray-100" }
const _hoisted_17 = { class: "fs-15px fw-400 text-cool-gray-100" }
const _hoisted_18 = { class: "fs-15px fw-400 text-cool-gray-100" }
const _hoisted_19 = { class: "fs-15px fw-400 text-cool-gray-100" }
const _hoisted_20 = { class: "fw-500 fs-15px text-cool-gray-100" }
const _hoisted_21 = { class: "fw-500 fs-15px text-cool-gray-100" }
const _hoisted_22 = {
  key: 1,
  class: "fs-13px fw-500 tex-cool-gray-100 q-mb-none q-mt-12"
}
const _hoisted_23 = { class: "fs-13px fw-500 text-cool-gray-80" }
const _hoisted_24 = {
  key: 2,
  class: "fs-13px fw-500 tex-cool-gray-100 q-mb-none q-mt-12"
}
const _hoisted_25 = { class: "fs-13px fw-500 text-cool-gray-80" }
const _hoisted_26 = {
  key: 1,
  class: "BaseJournalPopup full-height full-width column flex-center"
}
const _hoisted_27 = {
  key: 2,
  class: "BaseJournalPopup full-height column flex-center sticky-sidebar flex-1 flex-center"
}

import { formatDate } from 'src/common/helpers/generator/date.helper'
import { catchError } from 'src/common/helpers/generator/error.helper'
import { formatMonetaryAmount } from 'src/common/helpers/generator/monetaryAmount.helper'
import translate from 'src/common/helpers/language/translate'
import { AccountingJournalViewResponse, IAccountingJournalView } from 'src/common/interfaces'
import useNotify from 'src/hook/useNotify'
import { useAxios } from 'src/services/__vue_query__/api/fetchByApiClient'
import { handleAxiosResponse } from 'src/services/__vue_query__/api/helpers'
import { Endpoints } from 'src/services/__vue_query__/endpoints'
import { useBranchesStore } from 'src/stores'
import globalTranslateObject from 'src/translate/global.translate'
import { reactive, watch } from 'vue'

interface IProps {
  journalId: number
  storeId: number
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseJournalPopup' },
  __name: 'BaseJournalPopup',
  props: /*@__PURE__*/_mergeModels({
    journalId: {},
    storeId: {}
  }, {
    "modelValue": { type: Boolean, ...{ required: true } },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {


const props = __props
const model = _useModel<boolean>(__props, "modelValue")

const { t: globalT } = translate(globalTranslateObject)

const { notify } = useNotify()
const branchesStore = useBranchesStore()
const currency_code = branchesStore.all_store_objects[props.storeId]?.currency_code ?? 'gbp'
const state = reactive({ loading: false, journal: {} as IAccountingJournalView, totalDebit: 0, totalCredit: 0 })

const columns = [
  {
    name: 'id',
    align: 'left',
    label: '#',
    field: 'id',
    type: 'text',
    export: true,
    headerClasses: 'table-column-fit-content',
  },

  {
    name: 'Subsidiary',
    align: 'left',
    label: globalT('subsidiary'),
    field: 'subsidiary_ledger',
    type: 'text',
    export: true,
    headerClasses: 'table-column-fit-content',
  },
  {
    name: 'Sub-ledgers',
    align: 'left',
    label: globalT('sub_ledgers'),
    field: 'subledger',
    type: 'text',
    export: true,
    headerClasses: 'table-column-fit-content',
  },
  {
    name: 'Account_name',
    align: 'left',
    label: globalT('account_name'),
    field: 'account_name',
    type: 'text',
    export: true,
    headerClasses: 'table-column-fit-content',
  },
  {
    name: 'currency',
    align: 'left',
    label: globalT('currency'),
    field: 'currency',
    type: 'text',
    export: true,
    headerClasses: 'table-column-fit-content',
  },
  {
    name: 'text',
    align: 'left',
    label: globalT('debit'),
    field: 'amount',
    type: 'text',
    export: true,
    headerClasses: 'table-column-fit-content',
  },
  {
    name: 'text',
    align: 'left',
    label: globalT('credit'),
    field: 'amount',
    type: 'text',
    export: true,
    headerClasses: 'table-column-fit-content',
  },
]

async function getData() {
  try {
    state.loading = true
    const filter = { journal_id: props.journalId, store_id: props.storeId }
    const request = useAxios<AccountingJournalViewResponse>(Endpoints.ACCOUNTING_JOURNAL_VIEW, { filter })
    await request.fetch()
    const { data } = handleAxiosResponse<AccountingJournalViewResponse>(request)
    state.journal = data
    calculateDebitCreditTotal()
  } catch (err) {
    const errors = catchError(err)
    for (const error of errors) notify(false, error)
  } finally {
    state.loading = false
  }
}

function calculateDebitCreditTotal() {
  if (state.journal && state.journal?.transactions && state.journal?.transactions.length) {
    state.journal.transactions.forEach((item) => {
      const amount = parseFloat(item.amount)
      if (amount > 0) {
        state.totalDebit += amount
      } else if (amount < 0) {
        state.totalCredit -= amount
      }
    })
  }
}

watch(model, async () => {
  if (model.value) await getData()
})

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_table = _resolveComponent("k-table")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_EmptyListAlert = _resolveComponent("EmptyListAlert")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createBlock(_component_k_dialog, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
    title: `${_unref(globalT)('journal_id')}: ${__props.journalId}`,
    class: "BaseJournalPopup__wrapper",
    "container-class": "column no-wrap overflow-hidden",
    "content-class": "overflow-auto hide-scrollbar"
  }, {
    content: _withCtx(() => [
      (!state.loading && state.journal.id)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_k_icon, {
                    name: "calendar",
                    color: "cool-gray-70"
                  }),
                  _createElementVNode("p", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(globalT)('date')) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(_unref(formatDate)(state.journal.created_at, 'DD/MM/YYYY')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_k_icon, {
                    name: "clock",
                    color: "cool-gray-70"
                  }),
                  _createElementVNode("p", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(globalT)('time')) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(_unref(formatDate)(state.journal.created_at, 'HH:mm')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_k_icon, {
                    name: "list-3",
                    color: "cool-gray-70"
                  }),
                  _createElementVNode("p", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(globalT)('type')) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(state.journal.kind_str), 1)
                  ])
                ])
              ]),
              (state.journal.transactions && state.journal.transactions.length)
                ? (_openBlock(), _createBlock(_component_k_table, {
                    key: 0,
                    columns: columns,
                    rows: state.journal.transactions,
                    "has-footer": false
                  }, {
                    body: _withCtx(({ localProps: { row, rowIndex } }) => [
                      _createVNode(_component_q_tr, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(row.id), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(row.subsidiary_ledger), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_15, _toDisplayString(row.subledger), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_16, _toDisplayString(row.account_name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(row.currency_code), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(Number(row.amount) > 0
                        ? _unref(formatMonetaryAmount)(Number(row.amount), row.currency_code ?? 'gbp')
                        : '_'), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_td, null, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(Number(row.amount) < 0
                        ? _unref(formatMonetaryAmount)(Number(row.amount) * -1, row.currency_code ?? 'gbp')
                        : '_'), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_tr, { class: "table-body-separator" }, {
                        default: _withCtx(() => [
                          (rowIndex < state.journal.transactions.length - 1)
                            ? (_openBlock(), _createBlock(_component_q_td, {
                                key: 0,
                                class: "separator",
                                colspan: "100%"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_k_divider, { dotted: "" })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024),
                      (rowIndex === state.journal.transactions.length - 1)
                        ? (_openBlock(), _createBlock(_component_q_tr, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_td, { colspan: "5" }),
                              _createVNode(_component_q_td, { class: "BaseJournalPopup__debit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(formatMonetaryAmount)(state.totalDebit, _unref(currency_code))), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_td, { class: "BaseJournalPopup__credit" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(formatMonetaryAmount)(state.totalCredit, _unref(currency_code))), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["rows"]))
                : _createCommentVNode("", true),
              (state.journal.ref)
                ? (_openBlock(), _createElementBlock("p", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(globalT)('reference')) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(state.journal.ref), 1)
                  ]))
                : _createCommentVNode("", true),
              (state.journal.description)
                ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(globalT)('description')) + ": ", 1),
                    _createTextVNode(" " + _toDisplayString(state.journal.description), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_q_spinner, {
                size: "4em",
                color: "cool-gray-40"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createVNode(_component_EmptyListAlert, {
                title: _unref(globalT)('no_journal_data'),
                icon: "no-data"
              }, null, 8, ["title"])
            ]))
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})